module.exports = __webpack_public_path__ + "img/fjm-logo-blanc.2bb32ccd.svg";